import { render, staticRenderFns } from "./TrainingItemConfig.vue?vue&type=template&id=1ff60543&scoped=true&"
import script from "./TrainingItemConfig.vue?vue&type=script&lang=js&"
export * from "./TrainingItemConfig.vue?vue&type=script&lang=js&"
import style0 from "./TrainingItemConfig.vue?vue&type=style&index=0&id=1ff60543&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff60543",
  null
  
)

export default component.exports